"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClusters = getClusters;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var portalId = _hubspot.default.get();

function getClusters(initialCrawl) {
  var getAnalytics = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return _apiClient.default.get('/content-clusters/v1/clusters', {
    query: {
      portalId: portalId,
      initialCrawl: initialCrawl,
      getAnalytics: getAnalytics
    }
  });
}